import React, { useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import BannerComponent from "./Banner/index.tsx";
import Plan from "./Plan/index.tsx";
import Resources from "./Resources/index.tsx";
import Summary from "./Summary/index.tsx";
import Utils from "../../lib/utils";

import { getSubscriptions } from "../../redux/middleware/subscription";

const Index = ({ getSubscriptions, subscriptions, history, user }) => {
  useEffect(() => getSubscriptions(), []);

  const onClick = (plan) => {
    const cart = Utils.getCart();
    const updateCart = {
      ...cart,
      plan,
    };
    Utils.setCart(updateCart);
    if (Utils.isSignedIn() && user && user.role === "employer") {
      history.push("/payment");
    } else {
      history.push("/employer-signup");
    }
  };

  return (
    <div>
      <BannerComponent />
      <Summary />
      <Plan onClick={onClick} subscriptions={subscriptions} />
      <Resources />
    </div>
  );
};

const mapStateToProps = (state) => ({
  subscriptions: state.subscription.subscriptions,
  user: state.userByToken.user,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getSubscriptions,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Index);
